import React, { Component } from 'react';
import './App.css';
import { getMedalistsFromSpreadSheet } from './Medalists';
import { Card } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CardActionArea from '@material-ui/core/CardActionArea';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, ThemeProvider, useTheme, createMuiTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';

const darkTheme = createMuiTheme({
  palette: {
    // Switching the dark mode on is a single property value change.
    type: 'dark',
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { nameSearch : '', yearSearch : '2021', currentTab: 0, moreInfo: false, medalists: { "Medalists" : [] }};
    this.years = [];
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.filteredMedalists = this.filteredMedalists.bind(this);
    this.fullName = this.fullName.bind(this);
    this.tabChanged = this.tabChanged.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);

    this.inputName = React.createRef();
    this.inputYear = React.createRef();

    var availableYears = new Set([]);
    getMedalistsFromSpreadSheet().then(medalists => {
      medalists.Medalists.map(function(object, index) {
       if (object !== undefined) {
         availableYears.add(object.year);
       }
     });
     this.years = Array.from(availableYears.keys()).sort();
     const latestYear = this.years[this.years.length - 1];
     this.setState({ ...this.state, medalists: medalists, yearSearch: latestYear});
     });
  }

  tabChanged(event, newValue) {
    this.setState({ ...this.state, currentTab: newValue });
  }

  handleNameChange(event) {
    this.setState({ ...this.state, nameSearch : event.target.value });
  }

  handleYearChange(event) {
    this.setState({ ...this.state, yearSearch: event.target.value });
  }

  toggleDrawer(setIsOpen, object) {
    if (!setIsOpen) {
      this.setState({ ...this.state, moreInfo: false, dialogTitle: null, dialogBio: null, dialogImgSrc: null});
    }
    const hasObj = object !== undefined;
    if (hasObj && (object.bio || this.getImageSrc(object) !== "empty.png")) {
      this.setState({ ...this.state, 
        moreInfo: true, 
        dialogTitle: this.fullName(object), 
        dialogBio: object.bio, 
        dialogImgSrc: this.getImageSrc(object)
      });
    }
  }

  fullName(object) {
    var result = '';
    if (object.prefix !== undefined) {
      result = object.prefix;
    }
    if (result !== '' && object.first !== undefined) {
      result += ' ';
    }
    if (object.first !== undefined) {
      result += object.first;
    }
    if (result !== '' && object.middle !== undefined) {
      result += ' ';
    }
    if (object.middle !== undefined) {
      result += object.middle;
    }
    if (result !== '' && object.last !== undefined) {
      result += ' ';
    }
    if (object.last !== undefined) {
      result += object.last;
    }
    return result;
  }

  filteredMedalists() {
    const that = this;
    return this.state.medalists.Medalists.filter(function(object) {
      var yearMatch = false;
      if (object.year == that.state.yearSearch || that.state.yearSearch == '*') {
        const fullName = that.fullName(object).toLowerCase();
        return fullName.includes(that.state.nameSearch.toLowerCase());
      }
      return false;
    });
  }

  societyMedalists() {
    return this.state.medalists.Medalists.filter(function(object) {
      return object.is_society_member;
    });
  }

  renderRecipientsGrid() {
    const filteredMedalists = this.filteredMedalists();
    const that = this;
    return (
    <Container>
      <Container style={{padding:"20px"}}>
        <Grid container justify="flex-start" alignItems="flex-start" style={{width:"100%"}}>
          <Grid item>
            <TextField autoComplete="off" ref={this.inputName} value={this.state.nameSearch} label="Name Search" variant="outlined" type="text" name="name" onChange={this.handleNameChange} />
          </Grid>
          <Grid item xs={1} />
          <Grid item>
            <FormControl style={{minWidth:120}}>
              <InputLabel id="demo-simple-select-placeholder-label-label">
                Year Search
              </InputLabel>
            <Select
              autoComplete="off" 
              onChange={this.handleYearChange}
              value={this.state.yearSearch}
              >
                <MenuItem value="*" key="*">All Years</MenuItem>
                {this.years.map(function(object, index) {
                  const yearTitle = object === undefined ? "Unknown" : object;
                  return <MenuItem value={object} key={index}>{yearTitle}</MenuItem>
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Container>
      <Grid container justify="flex-start" alignItems="flex-start" style={{width:"100%"}} spacing={2} >
        {filteredMedalists.map(function(object, index) {
          return <Grid key={index} item xs={6} sm={4} md={3}><Card style={object.is_society_member ? {backgroundColor: "#8DBACE"} : {} }><CardActionArea onClick={() => that.toggleDrawer(true, object)}>
                        <CardContent><Typography>
                          {that.fullName(object)}</Typography>
                        </CardContent>
                        <CardContent>
                          <Typography color="textSecondary">
                            {object.year} 
                          </Typography>
                        </CardContent>
                      </CardActionArea></Card></Grid>
        })}
      </Grid>
    </Container>
  );
}

  getImageSrc(object) {
    if (object === undefined || object.id === undefined || object.profile_photo_file_name === undefined || object.profile_photo_file_name.trim().length == 0) {
      return "empty.png";
    }

    //return "https://s3.amazonaws.com/neco-production/medalists/profile_photos/000/0"+ object.id.substr(0, 2) + "/" + object.id.substr(2, 3) + "/original/" + object.profile_photo_file_name;
    return "medalists/" + object.profile_photo_file_name;
  }

  renderSocietyCard(object) {
    const that = this;
    const imgSrc = this.getImageSrc(object);
    return (
      <Grid key={object.id} item xs={12} sm={6} md={4}>
        <Card>
          <CardActionArea onClick={() => this.toggleDrawer(true, object)}>
          <CardHeader
            title={that.fullName(object)}
            subheader={object.year + " Medalist"}
          />

          <CardContent>
            { imgSrc ? <center><img src={imgSrc} width="200px" /></center> : null }
            <Typography variant="body2" color="textSecondary" component="p">
              Learn more about {that.fullName(object)}.
            </Typography>
          </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    );
  }

  renderSociety() {
    const societyMedalists = this.societyMedalists();
    const that = this;
    return (
      <Container style={{padding:"20px"}}>
        <Grid container justify="flex-start" alignItems="flex-start" style={{width:"100%"}} spacing={2}>
        {societyMedalists.map(function(object, index) {
          return that.renderSocietyCard(object);
        })}
        </Grid>
      </Container>
    );
  }

  renderMainTab() {
    if (this.state.currentTab == 0) {
      return this.renderRecipientsGrid();
    } else {
      return this.renderSociety();
    }
  }

  render() {
    const that = this;
    return (
      <div className="App" style={{backgroundColor: "#F0F0F0"}}>
        <ThemeProvider>
        <AppBar position="static" color="inherit">
          <Toolbar>
            <img src="logo.png" width="44" height="44" />
            <Typography variant="h6" noWrap>
              Ellis Island Medals of Honor Archive
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper square>
          <Tabs
            value={this.state.currentTab}
            onChange={this.tabChanged}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            >
              <Tab label="Recipients" id={0} />
              <Tab label="Honors Society" id={1} />
            </Tabs>
        </Paper>
        {this.renderMainTab()}
                <Dialog open={that.state.moreInfo} onClose={() => that.toggleDrawer(false)}>
          <DialogTitle style={{justifyContent: 'space-between'}}>
            {that.state.dialogTitle}
          <Button onClick={() => that.toggleDrawer(false)} color="primary">
            close
          </Button>
          </DialogTitle>
          <DialogContent>
            { (that.state.dialogImgSrc && that.state.dialogImgSrc !== "empty.png") ? <center><img src={that.state.dialogImgSrc} width="250px" /></center> : null }
            <DialogContentText>
              <div dangerouslySetInnerHTML={{ __html: that.state.dialogBio}} />
            </DialogContentText>
          </DialogContent>
      </Dialog>
        </ThemeProvider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js